import { Machine } from "xstate";
import { AppListModule } from "@/store/modules/listmanager.module";
import { toaster } from "@/utilities/toaster";
const listMasterMachine = Machine({
    id: "listMasterMachine",
    context: {
        masterId: "",
    },
    initial: "idle",
    states: {
        idle: {
            always: [{ target: "gettingLists" }],
        },
        gettingLists: {
            invoke: {
                id: "gettingLists",
                src: (ctx, event) => {
                    return AppListModule.GetMasters();
                },
                onDone: { target: "loadedLists" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedLists: {
            on: {
                ADDING_LIST: { target: "addingList" },
                EDIT_LIST: { target: "editingList" },
                DELETE_LIST: { target: "deleteList" },
                LOAD_LISTITEMS: { target: "gettingListItems" },
            },
        },
        deleteList: {
            tags: "showDeleteListUI",
            on: {
                DELETING_LIST: { target: "deletingList" },
                CANCEL_DELETE_LIST: { target: "gettingLists" },
            },
        },
        deletingList: {
            tags: "showDeleteListUI",
            invoke: {
                id: "deletingList",
                src: (ctx, evt) => AppListModule.DeleteMaster(evt.masterId),
                onDone: { target: "gettingLists", actions: ["showSuccessMessage"] },
                onError: { target: "loadedLists" },
            },
        },
        addingList: {
            tags: "showAddListUI",
            on: {
                SAVE_LIST: { target: "savingList" },
                CANCEL_ADDING_LIST: { target: "loadedLists" },
            },
        },
        savingList: {
            tags: "showAddListUI",
            invoke: {
                id: "savingList",
                src: (ctx, evt) => AppListModule.AddMaster(evt.newList),
                onDone: { target: "gettingLists", actions: ["showSuccessMessage"] },
                onError: { target: "gettingLists" },
            },
        },
        editingList: {
            tags: "showEditListUI",
            on: {
                UPDATE_LIST: { target: "updateList" },
                CANCEL_EDITING_LIST: { target: "loadedLists" },
            },
        },
        updateList: {
            tags: "showEditListUI",
            invoke: {
                id: "updateList",
                src: (ctx, evt) => AppListModule.UpdateMaster(evt.updateList),
                onDone: { target: "gettingLists", actions: ["showSuccessMessage"] },
                onError: { target: "gettingLists" },
            },
        },
        gettingListItems: {
            tags: "showListItemsUI",
            invoke: {
                id: "gettingListItems",
                src: (ctx, event) => {
                    return AppListModule.GetDetails(ctx.masterId);
                },
                onDone: { target: "loadedListItems" },
                onError: { target: "serviceUnavailable" },
            },
        },
        loadedListItems: {
            tags: "showListItemsUI",
            initial: "listing",
            on: {
                ADDING_LIST_ITEM: { target: ".addListItem" },
                EDITING_LIST_ITEM: { target: ".editListItem" },
                CLOSE_LISTITEMS: { target: "gettingLists" },
                DELETE_LIST_ITEM: { target: ".deleteListItem" },
                LOAD_LISTITEMS: { target: "gettingListItems" },
            },
            states: {
                listing: {},
                addListItem: {
                    tags: "showAddListItemUI",
                    on: {
                        SAVING_LIST_ITEM: { target: "saveListItem" },
                        CANCEL_LIST_ITEM: { target: "listing" },
                    },
                },
                saveListItem: {
                    tags: "showAddListItemUI",
                    invoke: {
                        id: "savingListItem",
                        src: (ctx, evt) => AppListModule.AddDetail(evt.newListItem),
                        onDone: { target: "#listMasterMachine.loadedListItems", actions: ["showSuccessMessage"] },
                        onError: { target: "addListItem" },
                    },
                },
                editListItem: {
                    tags: "showListItemEditorUI",
                    on: {
                        UPDATE_LIST_ITEM: { target: "updateListItem" },
                        CANCEL_EDIT_LIST_ITEM: { target: "listing" },
                    },
                },
                updateListItem: {
                    tags: "showListItemEditorUI",
                    invoke: {
                        id: "updatingListItem",
                        src: (ctx, evt) => AppListModule.UpdateDetail(evt.updateListItem),
                        onDone: { target: "#listMasterMachine.loadedListItems", actions: ["showSuccessMessage"] },
                        onError: { target: "editListItem" },
                    },
                },
                deleteListItem: {
                    tags: "showListItemDeleteUI",
                    on: {
                        DELETING_LIST_ITEM: { target: "deletingListItem" },
                        CANCEL_DELETE_LIST_ITEM: { target: "listing" },
                    },
                },
                deletingListItem: {
                    tags: "showListItemDeleteUI",
                    invoke: {
                        id: "deletingListItem",
                        src: (ctx, evt) => AppListModule.DeleteDetail(evt.detailId),
                        onDone: { target: "#listMasterMachine.gettingListItems", actions: ["showSuccessMessage"] },
                        onError: { target: "listing" },
                    },
                },
            },
        },
        serviceUnavailable: { type: "final" },
    },
}, {
    actions: {
        showSuccessMessage: (context, event) => {
            toaster.ShowSuccess(event.data.successMessages[0]);
        },
    },
    guards: {},
    activities: {},
    services: {},
});
export default listMasterMachine;
